import React, {useCallback, useEffect, useState} from 'react';
import {apiErrorRaised, useApiErrorDispatch} from "../../context/api_error/ApiErrorIndex";
import {useProjectState} from "../../context/project/ProjectContext";
import {Templates} from "../../services/api/Templates";
import {createTemplateColumnRenderers} from "./Columns";

const TemplateItem = ({data, visibleColumns}) => {
  const projectState = useProjectState()
  const dispatchApiError = useApiErrorDispatch()
  const [template, setTemplate] = useState(data)
  const COLUMN_RENDERERS = React.useMemo(() => createTemplateColumnRenderers(), []);

  useEffect(() => {
    setTemplate(data)
  }, [data])

  const handleToggle = (e) => {
    const {name, checked} = e.target;
    if (checked) {
      Templates.activate(projectState.companyId, projectState.projectId, template.id).then((r) => {
        if (r?.status < 400) {
          setTemplate(template => ({...template, [name]: checked}))
        } else {
          apiErrorRaised(dispatchApiError, r?.response)
        }
      });
    } else {
      Templates.disable(projectState.companyId, projectState.projectId, template.id).then((r) => {
        if (r?.status < 400) {
          setTemplate(template => ({...template, [name]: checked}))
        } else {
          apiErrorRaised(dispatchApiError, r?.response)
        }
      });
    }
  }

  const getColumnProps = useCallback((columnId) => {
    const baseProps = {template, projectState};

    // Add column-specific props
    switch (columnId) {
      case 'status':
        return {
          ...baseProps,
          handleToggle,
        };
      default:
        return baseProps;
    }
  }, [template, projectState, handleToggle]);

  return (
    <>
      <tr>
        {visibleColumns.map(columnId => {
          const renderColumn = COLUMN_RENDERERS[columnId];
          if (!renderColumn) return null;

          const props = getColumnProps(columnId);
          return (
            <React.Fragment key={columnId}>
              {renderColumn(props)}
            </React.Fragment>
          );
        })}
      </tr>
    </>
  )
}

export default TemplateItem;
